var Component = require("!../../../../vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../../vue-loader/lib/selector?type=script&index=0!./component.vue"),
  /* template */
  require("!!../../../../vue-loader/lib/template-compiler?id=data-v-a880b378!../../../../vue-loader/lib/selector?type=template&index=0!./component.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./~/element-ui/packages/dialog/src/component.vue
// module id = 105
// module chunks = 2